import { useState, useEffect } from 'react';
import BaseModal from '@c/modals/BaseModal';
import type { UserBike } from 'models/shared';
import SearchByVehicleForm from './SearchByVehicleForm';

type DesktopSearchByVehicleProps = {
  isOpen: boolean;
  dismiss: () => void;
  onBikeComplete: (bike: UserBike) => void;
  variant?: 'add-to-garage' | 'filter';
  initialBike?: Partial<UserBike> | null;
};

export default function DesktopSearchByVehicle({
  isOpen,
  dismiss,
  onBikeComplete,
  variant = 'filter',
  initialBike,
}: DesktopSearchByVehicleProps) {
  const [searchQuery, setSearchQuery] = useState('');

  useEffect(() => {
    if (
      isOpen &&
      initialBike?.year &&
      initialBike?.make &&
      initialBike?.model
    ) {
      setSearchQuery(
        `${initialBike.year} ${initialBike.make} ${initialBike.model}`
      );
    } else if (isOpen && !initialBike) {
      setSearchQuery('');
    }
  }, [isOpen, initialBike]);

  return (
    <BaseModal
      isOpen={isOpen}
      dismiss={dismiss}
      title={
        variant === 'add-to-garage'
          ? 'Add Vehicle to Your Garage'
          : 'Find Your Vehicle'
      }
    >
      <div className="h-[50rem] w-[45rem] overflow-hidden p-8">
        <SearchByVehicleForm
          onBikeComplete={onBikeComplete}
          onDismiss={dismiss}
          searchQuery={searchQuery}
          setSearchQuery={setSearchQuery}
        />
      </div>
    </BaseModal>
  );
}
